import { Component, ErrorHandler, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
declare var $: any;
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import swal from 'sweetalert2';
import { UserService } from '../../../../shared/user.service';

@Component({
  selector: 'app-patient-view-form',
  templateUrl: './patient-view-form.component.html',
  styleUrls: ['./patient-view-form.component.css']
})
export class PatientViewFormComponent implements OnInit {

  dtOptions: any = {};
  mode: any;
  DOC_NOs: any;
  @ViewChild(DataTableDirective)
  datatableElement: DataTableDirective;
  data: any;
  dtTrigger: Subject<any> = new Subject();
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;
  P: any = {};
  StateData: any;
  State: any = [];
  District: any = [];
  DistrictData: any;
  fileToUpload: File;
  Document: any = [];
  temp: any = {};
  PD: any = {};
  DocumentList: any = [];
  title: string;
  PR_Id: number;
  photoImageUrl: any;
  AS_Photo: string;
  PR_Age: any;
  name: string;
  hide:any;
  formInvalid : boolean = false;
  numericpattern:any;

  constructor(private userService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler,) { }

  ngOnInit() {
    this.GetStateDropDown();
    this.GetDistrictDropDown();
    this.GetDocumentDropDown();
    this.route.params.subscribe(params => {
      this.PR_Id = params['PR_Id'];
      this.mode = params['mode'];
      this.name = localStorage.getItem('userName')
      if (this.name != null) {
// alert(this.name);
        this.Getpatientid(this.name)
      }


      if (this.PR_Id > 0) {

        this.GetByIdPatient(this.PR_Id)
      }
    });
    if (this.mode == 'View') {
      this.title = "View Patient ";
    }
    else if (this.mode == 'Edit') {
      this.title = "Edit Patient ";
    }
  }

  GetStateDropDown() {
    this.StateData = this.userService.GetStateDropDown();
    this.StateData.subscribe(
      (Resp: any) => {
        this.State = Resp.Result;
      }
    )
  }

  GetDistrictDropDown() {
    this.DistrictData = this.userService.GetDistrictDropDown();
    this.DistrictData.subscribe(
      (Resp: any) => {
        this.District = Resp.Result;
      }
    )
  }


  Getpatientid(name) {
    this.DistrictData = this.userService.GetPatientByid(name);
    this.DistrictData.subscribe(
      (Resp: any) => {
        this.District = Resp.Result;
      }
    )
  }
  GetDocumentDropDown() {
    debugger
    this.data = this.userService.GetDocumentDropDown();
    this.data.subscribe(
      (Resp: any) => {
        this.Document = Resp;
      }
    )
  }

  AddDocumentDetails(PD) {
    debugger;
    this.temp = {
      Doc_DocumentType: PD.Doc_DocumentType,
      Doc_DocumentName: PD.Doc_DocumentName,
      Doc_Id_ProofPath: PD.Doc_Id_ProofPath,
    }
    //covarhge ddl
    this.DocumentList.push(this.temp);
    this.PD = {};
  }

  CreatePatient(Patient, PR_Age: any) {
    debugger;
    Patient.DocumentModelList = this.DocumentList;
    Patient.PR_Age = PR_Age;
    this.PR_Age = Patient.PR_Age;
    this.data = this.userService.CreatePatient(Patient);
    this.data.subscribe(
      (response) => {
        swal('Success!', 'Patient Details Added Successfully .', 'success');
        // this.router.navigate(['/home/newpatient']);
        this.router.navigate(['/Patient-login']);
      }, (error) => {
        if (error.status == 401) {
          this.errorHandler.handleError(error);
        }
        else if (error.status == 400) {
          swal('Warning!', error.error.Message, 'warning');
        }
      });
  }

  UpdatePatient(Patient, PR_Age: any) {
    debugger;
    Patient.PR_Age = PR_Age;;
    this.data = this.userService.UpdatePatient(this.PR_Id, Patient);
    this.data.subscribe(
      (response) => {
        swal('Success!', ' Patient details updated Successfully .', 'success');
        this.router.navigate(['/home/newpatient']);
      }, (error) => {
        if (error.status == 401) {
          this.errorHandler.handleError(error);
        }
      });
  }

  imageUpload(file: FileList) {
    debugger;
        let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg|.png|JPEG|JPG)$/;   
        let s: any = file.item(0).size / 1024;
        let size: any = parseFloat(s).toFixed(2);
        let uploadedFilename = file.item(0).name;
        if (uploadedFilename.match(regex) && (size <= 5048)) {
          this.fileToUpload = file.item(0);
          var reader = new FileReader();
          reader.onload = (event: any) => {
          }
          reader.readAsDataURL(this.fileToUpload);
          const data = new FormData(); 
          data.append("UploadedImage", file.item(0));
          let x = this.userService.uploadImageRecovery(data);
          x.subscribe(
            (response) => {
            }, (error) => {
              let i: any = document.getElementById('PR_Photo');
              i.value = "";
              if (error.status == 400) {
                swal('Warning!', error.error.Message, 'warning');
              }
            });
        }
        else {
          let i: any = document.getElementById('PR_Photo');
          i.value = "";
          if (!uploadedFilename.match(regex))
            swal('Warning!', "Please upload PDF file with extension pdef or pdf", 'warning');
          else if (size > 2048)
            swal('Warning!', "Please upload image file less than 2mb", 'warning');
        }
      }

      getimageUrl() {
        let imagename = null;
        try {
          imagename = document.getElementById('PR_Photo');
          return imagename.files[0].name;
        }
        catch (e) {
          return null; 
        }
      }

  DocumentUpload(file: FileList) {
    debugger;
    let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;
    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    if (uploadedFilename.match(regex) && (size <= 5048)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      reader.onload = (event: any) => {
      }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.userService.uploadImageRecovery(data);
      x.subscribe(
        (response) => {
        }, (error) => {
          let i: any = document.getElementById('Doc_Id_ProofPath');
          i.value = "";
          if (error.status == 400) {
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('Doc_Id_ProofPath');
      i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload PDF file with extension pdef or pdf", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload image file less than 2mb", 'warning');
    }
  }

  getDocumentUrl() {
    let imagename = null;
    try {
      imagename = document.getElementById('Doc_Id_ProofPath');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }

  GetByIdPatient(PR_Id) {
    debugger;
    this.data = this.userService.GetByIdPatient(PR_Id);
    this.data.subscribe(
      (response: any) => {
        this.P = response;
        this.DocumentList = response.DocumentModelList;
        if (this.P.PR_DOB != null)
          this.P.PR_DOB = ((this.P.PR_DOB).split('T'))[0];
          this.CalculateAge(response.PR_DOB);
      }, (error) => {
      });
  }

  DocumentDetailsremove(i){ 
    swal({
      title: 'Are you sure?', text: "You want to delete!", type: 'warning', showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, delete it!'
    })     
    this.DocumentList.splice(i, 1);      
   }  

   CalculateAge(dateOfBirth) {
    this.data = this.userService.calculateAge(dateOfBirth);
    this.data.subscribe(
      (response: any) => {
        // if (response >= 18)
          this.PR_Age = response;
        // else {
        //   swal('Warning!', "Age cannot be less than 18 years to apply", 'warning');
        //   this.app.APP_PA_DOB = null;
        //   this.APP_PA_Age = null;
        // }
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/Pages/tasks/patientprofile-view/patient-view-form/patient-view-form.component.ts